var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8333 12.2292H9.16659C5.94493 12.2292 3.33325 14.8409 3.33325 18.0625H16.6666C16.6666 14.8409 14.0549 12.2292 10.8333 12.2292Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0001 9.7292C11.841 9.7292 13.3334 8.23681 13.3334 6.39586C13.3334 4.55491 11.841 3.06253 10.0001 3.06253C8.15913 3.06253 6.66675 4.55491 6.66675 6.39586C6.66675 8.23681 8.15913 9.7292 10.0001 9.7292Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.749ac6293e9c0dbb5d5e15c8115e3ccd.svg";
export { ForwardRef as ReactComponent };